module.exports = __webpack_public_path__ + "assets/5268f8db6b2e8ea9a3580a875c95c99e.png";